import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { TranslatableText } from '@dreryk/react-common';

import { AppointmentAdvancePaymentShowModalEventInterceptor } from '../interceptors/AppointmentAdvancePaymentShowModalEventInterceptor';

import { AdvancePaymentActionTrigger, AdvancePaymentActionVariant } from './AdvancePaymentActionTrigger';

type AdvancePaymentIssuePaymentActionLinkProps = {
   label: TranslatableText;
   appointmentId: AppointmentId;
   variant?: AdvancePaymentActionVariant;
};

export const AdvancePaymentIssuePaymentActionLink = (props: AdvancePaymentIssuePaymentActionLinkProps): JSX.Element => (
   <AppointmentAdvancePaymentShowModalEventInterceptor appointmentId={props.appointmentId}>
      <AdvancePaymentActionTrigger
         variant={props.variant ?? 'link'}
         testId={'generateLinkToPayment'}
         label={props.label}
      />
   </AppointmentAdvancePaymentShowModalEventInterceptor>
);
